// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"49ea97d5","335":"c222c77d","584":"2d3d65b7","599":"d7ed2f2f"}[chunkId] + ".chunk.js";
};